import React from 'react';
import ReactSelect, { components as components$1 } from 'react-select';
import { Checkbox } from './Checkbox.js';

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') { return; }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".ui-select__option.ui-select__option--is-focused{background-color:var(--color-primary-light)}.ui-select__option.ui-select__option--is-selected{background-color:var(--color-primary)}div.ui-select__control{border-color:var(--charcoal-gray-light);flex-wrap:nowrap}div.ui-select__control:hover{border-color:rgba(var(--white-rgb),.3)}div.ui-select__control.ui-select__control--is-focused{border-color:var(--color-primary)}div.ui-select-error__control,div.ui-select-error__control:hover{border-color:var(--color-error)}div.ui-select-error__input,div.ui-select-error__single-value,div.ui-select__input,div.ui-select__single-value{color:var(--white)}div.ui-select__single-value{left:25px;right:25px}div.ui-select__multi-value{background:var(--dropdown-item-hover)}div.ui-select__multi-value__label{color:var(--white);font-size:100%;padding:0}.react-select-menu-is-multi div.ui-select-error__menu,.react-select-menu-is-multi div.ui-select__menu{background-color:var(--annotation-footer)}.ui-select-error__menu-list--is-multi .ui-select-error__option,.ui-select__menu-list--is-multi .ui-select__option{color:var(--white)}.ui-select-error__menu-list--is-multi .ui-select-error__option:hover,.ui-select__menu-list--is-multi .ui-select__option:hover{background-color:var(--dropdown-item-hover)}";
styleInject(css_248z,{"insertAt":"top"});

var css_248z$1 = ".styles-module_MultiValueContainer__1VH7e,.styles-module_MultiValues__3lDL0{display:flex;align-items:center}.styles-module_MultiValueContainer__1VH7e{margin-left:-16px;padding:5px 0}.styles-module_MultiValues__3lDL0{flex-wrap:wrap}.styles-module_PlusBadge__1LagK{background:var(--dropdown-item-hover);font-size:11px;padding:4px 10px;border-radius:10px;margin:1px 2px}.styles-module_MultiOption__3Zmc6{display:flex;align-items:center}";
var styles = {"MultiValueContainer":"styles-module_MultiValueContainer__1VH7e","MultiValues":"styles-module_MultiValues__3lDL0","PlusBadge":"styles-module_PlusBadge__1LagK","MultiOption":"styles-module_MultiOption__3Zmc6"};
styleInject(css_248z$1,{"insertAt":"top"});

var BADGE_COUNT = 2;
var NullComponent = function () { return null; };
var MultiValue = function (_a) {
    var children = _a.children;
    var values = children[0], restOfChildren = children.slice(1);
    var valuesToRender = values.slice(0, BADGE_COUNT);
    var otherValues = values.slice(BADGE_COUNT);
    return (React.createElement("div", { className: styles.MultiValueContainer },
        React.createElement("div", { className: styles.MultiValues },
            valuesToRender.map(function (value) { return value; }),
            !!otherValues.length && (React.createElement("div", { className: styles.PlusBadge }, "+" + otherValues.length))),
        restOfChildren));
};
var ValueContainer = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(components$1.ValueContainer, __assign({}, props), props.isMulti && props.hasValue ? (React.createElement(MultiValue, null, children)) : (children)));
};
var Option = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(components$1.Option, __assign({}, props), props.isMulti ? (React.createElement("div", { className: styles.MultiOption, "data-cy": "select-multi-option", "data-value": props.value },
        React.createElement(Checkbox, { checked: props.isSelected }),
        children)) : (children)));
};
var Menu = function (props) { return (React.createElement("div", { className: props.isMulti ? 'react-select-menu-is-multi' : '' },
    React.createElement(components$1.Menu, __assign({}, props)))); };
var components = {
    ClearIndicator: NullComponent,
    ValueContainer: ValueContainer,
    MultiValueRemove: NullComponent,
    Option: Option,
    Menu: Menu,
};

var selectStyles = {
    menuPortal: function (base) { return (__assign(__assign({}, base), { zIndex: 9999 })); },
    control: function (base) { return (__assign(__assign({}, base), { fontSize: '12px', backgroundColor: 'transparent', borderRadius: 'var(--border-radius-medium)', boxShadow: 'none', border: '1px solid', transition: 'all ease-in-out 0.3s', cursor: 'pointer' })); },
    indicatorSeparator: function () { return ({
        display: 'none',
    }); },
    valueContainer: function () { return ({
        marginLeft: 23,
    }); },
    option: function (base, _a) {
        var isMulti = _a.isMulti;
        return isMulti
            ? __assign(__assign({}, base), { cursor: 'pointer', fontSize: 13, background: 'transparent', transition: 'background 0.2s' }) : __assign(__assign({}, base), { cursor: 'pointer' });
    },
    multiValue: function (base) { return (__assign(__assign({}, base), { fontSize: 11, padding: '4px 10px', borderRadius: 'var(--border-radius-medium)', margin: '1px 2px' })); },
};
var Select = function (_a) {
    var hasError = _a.hasError, id = _a.id, isDisabled = _a.isDisabled, isMulti = _a.isMulti, isSearchable = _a.isSearchable, _b = _a.menuPortalTarget, menuPortalTarget = _b === void 0 ? document.body : _b, onBlur = _a.onBlur, onChange = _a.onChange, options = _a.options, placeholder = _a.placeholder, title = _a.title, value = _a.value;
    return (React.createElement(ReactSelect, { classNamePrefix: hasError ? 'ui-select-error' : 'ui-select', onChange: function (selected) {
            var newValue = Array.isArray(selected)
                ? selected.map(function (_a) {
                    var _value = _a.value;
                    return _value;
                })
                : selected.value;
            return onChange(newValue);
        }, value: Array.isArray(value)
            ? value.map(function (_value) {
                return options.find(function (_a) {
                    var __value = _a.value;
                    return __value === _value;
                });
            })
            : options.find(function (_a) {
                var __value = _a.value;
                return __value === value;
            }), components: components, isMulti: isMulti, hideSelectedOptions: false, name: title, id: id, styles: selectStyles, options: options, menuPortalTarget: menuPortalTarget, isSearchable: isSearchable, placeholder: placeholder, onBlur: onBlur, isDisabled: isDisabled }));
};
Select.defaultProps = {
    hasError: false,
    placeholder: '...',
    isSearchable: false,
};

export { Select };
